// Copyright (c) 2017 PlanGrid, Inc.

import React, { Component } from 'react';
import * as THREE from 'three';

export default class Photo360Viewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manualControl: false,
      longitude: 0,
      latitude: 0,
      savedX: null,
      savedY: null,
      savedLongitude: null,
      savedLatitude: null
    };

    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
  }

  componentDidMount() {
    const el = document.getElementById('360-photo');
    const positionInfo = el.getBoundingClientRect();
    const height = positionInfo.height;
    const width = positionInfo.width;

    // Add renderer
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setSize(width, height);
    el.appendChild(this.renderer.domElement);

    // Create a new scene
    this.scene = new THREE.Scene();

    // Add a camera
    this.camera = new THREE.PerspectiveCamera(75, width / height, 1, 1000);
    this.camera.target = new THREE.Vector3(0, 0, 0);

    // Create a big sphere geometry
    this.sphere = new THREE.SphereGeometry(100, 100, 40);
    this.sphere.applyMatrix4(new THREE.Matrix4().makeScale(-1, 1, 1));

    // Create the sphere material
    this.sphereMaterial = new THREE.MeshBasicMaterial();
    this.sphereMaterial.map = this.props.texture;
    const sphereMesh = new THREE.Mesh(this.sphere, this.sphereMaterial);
    this.scene.add(sphereMesh);

    this.updateView();
  }

  componentDidUpdate() {
    this.updateView();
  }

  onMouseMove(event) {
    const { savedX, savedY, savedLongitude, savedLatitude } = this.state;

    if (this.state.manualControl) {
      const newLongitude = (savedX - event.clientX) * 0.1 + savedLongitude;
      const newLatitude = (event.clientY - savedY) * 0.1 + savedLatitude;
      this.setState({
        longitude: newLongitude,
        latitude: newLatitude
      });
    }
  }

  onMouseUp() {
    this.setState({ manualControl: false });
  }

  onMouseDown(event) {
    event.preventDefault();
    this.setState({
      savedLongitude: this.state.longitude,
      savedLatitude: this.state.latitude,
      savedX: event.clientX,
      savedY: event.clientY,
      manualControl: true
    });
  }

  updateView() {
    const { latitude, longitude } = this.state;
    const clampedLatitude = Math.max(-85, Math.min(85, latitude));

    // Move the camera according to the current latitude (vertical movement)
    // and longitude (horizontal movement)
    this.camera.target.x = 500 * Math.sin(THREE.MathUtils.degToRad(90 - clampedLatitude)) * Math.cos(THREE.MathUtils.degToRad(longitude));
    this.camera.target.y = 500 * Math.cos(THREE.MathUtils.degToRad(90 - clampedLatitude));
    this.camera.target.z = 500 * Math.sin(THREE.MathUtils.degToRad(90 - clampedLatitude)) * Math.sin(THREE.MathUtils.degToRad(longitude));
    this.camera.lookAt(this.camera.target);

    this.renderer.render(this.scene, this.camera);
  }

  render() {
    return (
      <div
        id="360-photo"
        className="photo360"
        onMouseDown={this.onMouseDown}
        onMouseMove={this.onMouseMove}
        onMouseUp={this.onMouseUp}
      />
    );
  }
}
